import {type FC} from "react"
import {Box} from "@mui/material"
import {ErrorMessage} from "../ErrorMessage"
import {
  ErrorMessageAskExpert,
  ExpertNoResultMessage,
} from "../../atoms/errorMessages/ErrorMessageElements"

type Props = {
  isError: boolean
  refetch: () => void
}

const errorMessage: FC<Props> = (props) => {
  return (
    <Box
      style={{
        flexGrow: 0,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "27px",
        padding: "16px 8px 24px 24px",
        background: "#FFFFFF",
      }}
    >
      {!props.isError ? (
        <ErrorMessage
          containerStyle={{}}
          message=""
          messageElement={ExpertNoResultMessage}
          messageStyle={{}}
          refetch={props.refetch}
          hideRefreshButton={true}
        />
      ) : (
        <ErrorMessage
          message=""
          containerStyle={{}}
          messageElement={ErrorMessageAskExpert}
          messageStyle={{}}
          refetch={props.refetch}
          buttonContainerStyle={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        />
      )}
    </Box>
  )
}

export default errorMessage
